module.exports = __webpack_public_path__ + "static/img/brees-2003-top-image.d0ee49c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-top-image.jpg
// module id = rkqA
// module chunks = 1